import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

const Request = React.lazy(() => import(/* webpackChunkName: "Request" */ './Request'));
const Confirm = React.lazy(() => import(/* webpackChunkName: "Confirm" */ './Confirm'));

export default () => {
  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Route path="/:uuid" exact component={Confirm} />
        <Route path="/" exact component={Request} />
      </Switch>
    </Suspense>
  );
};
